export function Spinner({ className = '' }: { className?: string }) {
  return (
    <div
      className={`inline-block w-5 h-5 border-2 rounded-full animate-spin ${className}`}
      style={{
        borderColor: 'var(--color-accent-dim)',
        borderTopColor: 'var(--color-accent)',
      }}
    />
  )
}
